(function () {
  "use strict";

  const BLOG_ROOT_SELECTOR = ".blog";
  const CATEGORIES_SELECTOR = ".js-articles-counter";
  const TAG_LINK_SELECTOR = ".js-article-tag";
  const ARTICLES_ROW_SELECTOR = ".js-blog-row";
  const LOAD_MORE_SELECTOR = ".js-load-more-wrapper";

  const ACTIVE_CLASS = "active";
  const LOADING_CLASS = "is-loading";
  const LOADMORE_LOADING_CLASS = "loading";

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function safeUrl(href) {
    try {
      return new URL(href, window.location.href);
    } catch (e) {
      return null;
    }
  }

  function sameOrigin(href) {
    const u = safeUrl(href);
    return !!u && u.origin === window.location.origin;
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, "text/html");
  }

  function reinitObservers() {
    if (typeof window.initializeObservers === "function") {
      try {
        window.initializeObservers();
      } catch (e) {
        console.warn("[blog] initializeObservers() error:", e);
      }
    }
  }

  function initCategoryCounters() {
    const list = document.querySelector(CATEGORIES_SELECTOR);
    if (!list) return;

    const links = list.querySelectorAll(TAG_LINK_SELECTOR);
    if (!links.length) return;

    links.forEach((link) => {
      const span = link.querySelector(".js-get-articles-counter");
      const href = link.getAttribute("href");
      if (!href || !span) return;

      fetch(href, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then((res) => res.text())
        .then((html) => {
          const doc = parseHTML(html);
          const counterEl = doc.querySelector(CATEGORIES_SELECTOR);
          const count = counterEl ? counterEl.getAttribute("data-counter") : null;

          if (count != null) span.textContent = count;
        })
        .catch((err) => {
          console.warn("[blog] Counter fetch error for " + href, err);
        });
    });
  }

  const Infinite = (function () {
    let observer = null;
    let observedEl = null;
    let ticking = false;
    let listenersBound = false;

    function getWrapper() {
      return document.querySelector(LOAD_MORE_SELECTOR);
    }

    function getRow() {
      return document.querySelector(ARTICLES_ROW_SELECTOR);
    }

    function isNearViewport(el, offset) {
      if (!el) return false;
      const r = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      return r.top <= vh + offset;
    }

    function scheduleCheck() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(checkAndMaybeLoad);
    }

    function ensureWrapperVisibleTarget(w) {
      if (!w.style.minHeight) w.style.minHeight = "1px";
      if (!w.style.display) w.style.display = "block";
    }

    function loadNext() {
      const w = getWrapper();
      const row = getRow();
      if (!w || !row) return;

      if (w.classList.contains(LOADMORE_LOADING_CLASS)) return;

      const url = w.dataset.url;
      if (!url) return;

      w.classList.add(LOADMORE_LOADING_CLASS);

      fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then((r) => r.text())
        .then((html) => {
          const doc = parseHTML(html);

          const newArticles = doc.querySelectorAll(ARTICLES_ROW_SELECTOR + " > *");
          newArticles.forEach((el) => row.appendChild(el));

          const nextWrapper = doc.querySelector(LOAD_MORE_SELECTOR);

          if (nextWrapper && nextWrapper.dataset.url) {
            w.dataset.url = nextWrapper.dataset.url;
            w.classList.remove(LOADMORE_LOADING_CLASS);
          } else {
            // koniec
            try {
              if (observer) observer.unobserve(w);
            } catch (e) {}
            w.remove();
          }

          reinitObservers();

          requestAnimationFrame(() => requestAnimationFrame(checkAndMaybeLoad));
        })
        .catch((err) => {
          console.warn("[blog] Infinite scroll fetch error:", err);
          w.classList.remove(LOADMORE_LOADING_CLASS);
        });
    }

    function checkAndMaybeLoad() {
      ticking = false;

      const w = getWrapper();
      const row = getRow();
      if (!w || !row) return;

      ensureWrapperVisibleTarget(w);

      if (isNearViewport(w, 500)) {
        loadNext();
      }
    }

    function createObserverIfNeeded() {
      if (observer || !("IntersectionObserver" in window)) return;

      observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              loadNext();
              break;
            }
          }
        },
        { rootMargin: "500px 0px" }
      );
    }

    function bindListenersOnce() {
      if (listenersBound) return;
      listenersBound = true;

      window.addEventListener("scroll", scheduleCheck, { passive: true });
      window.addEventListener("resize", scheduleCheck);
    }

    function setup() {
      const w = getWrapper();
      const row = getRow();
      if (!w || !row) return;

      ensureWrapperVisibleTarget(w);

      bindListenersOnce();
      createObserverIfNeeded();

      if (observer) {
        if (observedEl) {
          try {
            observer.unobserve(observedEl);
          } catch (e) {}
        }
        observedEl = w;
        observer.observe(w);
      }

      scheduleCheck();
    }

    function init() {
      requestAnimationFrame(() => requestAnimationFrame(setup));
    }

    return { init };
  })();

  const AjaxTags = (function () {
    const blogRoot = document.querySelector(BLOG_ROOT_SELECTOR);
    if (!blogRoot) return { init: function () {} };

    function setActive(url) {
      const categories = document.querySelector(CATEGORIES_SELECTOR);
      if (!categories) return;

      const links = categories.querySelectorAll(TAG_LINK_SELECTOR);
      links.forEach((link) => link.classList.remove(ACTIVE_CLASS));

      const u = safeUrl(url);
      if (!u) return;

      const targetPath = u.pathname.replace(/\/+$/, "");

      links.forEach((link) => {
        const lu = safeUrl(link.href);
        if (!lu) return;

        const linkPath = lu.pathname.replace(/\/+$/, "");
        if (linkPath === targetPath) {
          link.classList.add(ACTIVE_CLASS);
        }
      });
    }

    function fetchPage(url) {
      return fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } }).then((r) => {
        if (!r.ok) throw new Error("Fetch error: " + r.status);
        return r.text();
      });
    }

    function replaceContent(html) {
      const doc = parseHTML(html);

      const newRow = doc.querySelector(ARTICLES_ROW_SELECTOR);
      const newLoadMore = doc.querySelector(LOAD_MORE_SELECTOR);

      const currentRow = document.querySelector(ARTICLES_ROW_SELECTOR);
      const currentLoadMore = document.querySelector(LOAD_MORE_SELECTOR);

      if (!newRow || !currentRow) return;

      currentRow.replaceWith(newRow);

      if (currentLoadMore) {
        if (newLoadMore) {
          currentLoadMore.replaceWith(newLoadMore);
        } else {
          currentLoadMore.remove();
        }
      } else if (newLoadMore) {
        const rowNow = document.querySelector(ARTICLES_ROW_SELECTOR);
        if (rowNow) rowNow.insertAdjacentElement("afterend", newLoadMore);
      }

      reinitObservers();

      Infinite.init();

      document.dispatchEvent(new CustomEvent("blog:ajax:updated"));
    }

    function loadCategory(url, pushState) {
      if (!sameOrigin(url)) {
        window.location.href = url;
        return;
      }

      blogRoot.classList.add(LOADING_CLASS);

      fetchPage(url)
        .then((html) => {
          replaceContent(html);
          setActive(url);

          if (pushState) {
            history.pushState({ ajax: true, url }, "", url);
          }

          blogRoot.scrollIntoView({ behavior: "smooth", block: "start" });
        })
        .catch((e) => {
          console.error("[blog] AJAX tag error:", e);
          window.location.href = url;
        })
        .finally(() => {
          blogRoot.classList.remove(LOADING_CLASS);
        });
    }

    function onClick(e) {
      const link = e.target.closest(TAG_LINK_SELECTOR);
      if (!link) return;

      if (!link.closest(CATEGORIES_SELECTOR)) return;

      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      e.preventDefault();
      loadCategory(link.href, true);
    }

    function onPopState(e) {
      if (e.state && e.state.ajax && e.state.url) {
        loadCategory(e.state.url, false);
      } else {
        loadCategory(window.location.href, false);
      }
    }

    function init() {
      document.addEventListener("click", onClick);
      window.addEventListener("popstate", onPopState);

      onReady(function () {
        setActive(window.location.href);
      });
    }

    return { init };
  })();

  onReady(function () {
    initCategoryCounters();
    Infinite.init();
    AjaxTags.init();
  });
})();